import React from "react";
import { color, motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import bannerVideo from "../../Assets/videos/bannervideo.mp4";
import topBg from "../../Assets/image 33.png";
import planet from "../../Assets/image (1).png";
import bottomBg from "../../Assets/about/aboutbottom.png";
import spaceObj from "../../Assets/image 38.png";
import "./AboutVideoSection.css";
import bgVideo from "../../Assets/videos/loop.mp4";

const AboutVideoSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.3, triggerOnce: true });

  React.useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        scale: 1,
        rotateX: 0,
        transition: { duration: 2, ease: "easeOut" },
      });
    }
  }, [inView, controls]);

  return (
    <div className="Aboutvideo-wrapper">
            <div className="video-bg">
              <video
                src={bgVideo}
                autoPlay
                loop
                muted
                playsInline
                className="bg-video"
              />
            </div>
      <h1 className="Aboutvideo-title">Built On Values<br />Growing with Vision</h1>
       {/* <img 
       src={topBg} 
       alt="top background"
        className="Abouttop-bg" /> */}
      <motion.img
  // src={planet}
  // alt="center planet"
  className="Aboutplanet-animated"
  animate={{ y: [0, -30, 0] }}
  transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
/>
      <motion.div
  className="Aboutvideo-section"
  ref={ref}
  initial={{ opacity: 0, scale: 0.8, rotateX: 35 }}
  animate={controls}
>

  {/* Left Hand */}
  <img src={require("../../Assets/about/image 77.png")} alt="left hand" className="About-left-hand" />

  {/* Right Hand */}
  <img src={require("../../Assets/about/image 78.png")} alt="right hand" className="About-right-hand" />

  {/* Logo/Text inside hands */}
  <div className="About-logo-frame">
    <img src={require("../../Assets/about/Group 1597883476.png")} alt="VCNR logo" className="About-logo" />
  </div>


  <img src={spaceObj} alt="corner object" className="Aboutcorner-object" />
</motion.div>
      <img src={bottomBg} alt="bottom background" className="Aboutbottom-bg" />
    </div>
  );
};

export default AboutVideoSection;
